import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { HttpResponse } from '@angular/common/http';
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Pais } from 'src/app/shared/models/pais';
import { ReporteExcelUsuarios } from 'src/app/shared/models/reporteExcelUsuarios';
import { ReportesService } from 'src/app/shared/services/reportes.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Usuario } from 'src/app/shared/models/usuario';
import { UsuariosDataGrilla } from 'src/app/shared/models/usuariosDataGrilla';
import { UsuariosDialogComponent } from './usuarios-dialog.component';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  animations: [

    trigger('detailExpand', [

      state('collapsed', style({ height: '0px', minHeight: '0' })),

      state('expanded', style({ height: '*' })),

      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),

    ]),

  ],

})

export class UsuariosComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private reportesSevice: ReportesService,
    private router: Router,
    private snackBarService: SnackbarService,
    private usuariosService: UsuariosService,
    public exporExcelService: ExcelService,
    private sidenav: SidenavService) {
  }

  botonReporte: string = "";
  dataSource = new MatTableDataSource<Usuario>();
  displayedColumns = ['acciones', 'userName', 'nombreApellido', 'rol', 'habilitacion'];
  displayedColumnsExpand = [...this.displayedColumns, 'expand'];
  divisionesUsuario: string = "";
  expandedElement: Usuario | null
  loadingReporte: boolean = false;
  loadingSubidaExcel: boolean = false;
  paisesUsuario: string = "";
  rolesConRegion: ItemParametro[] = [];
  rolesMultiDivision: ItemParametro[] = [];
  usuarioSeleccionado: Usuario;

  public Etiquetas: {

    BotonAUsuario: string;
    BotonAUsuariosExcel: string;
    BotonCPlantillaExcel: string;
    Buscar: string;
    SinRegistros: string;
    Titulo: string;


    Total: string
    Headers: {
      Acciones: string,
      Email: string,
      Habilitacion: string
      Nombre: string
      UserName: string,
      Rol: string

    }
  }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }

  ngOnInit() {
    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADM LOCAL')) {
      this.router.navigateByUrl('');
    }
    else {
      this.botonReporte = this.configService.etiquetas.BotonReporte;
      this.loadingReporte = false;
      this.Etiquetas = {
        BotonAUsuario: this.configService.etiquetas.Usuarios.BotonAUsuario,
        BotonAUsuariosExcel: this.configService.etiquetas.BotonAExcel,
        BotonCPlantillaExcel: this.configService.etiquetas.BotonCPlantillaExcel,
        Buscar: this.configService.etiquetas.Buscar,
        SinRegistros: this.configService.etiquetas.SinRegistros,
        Titulo: this.configService.etiquetas.Usuarios.Titulo,
        Total: this.configService.etiquetas.Total,

        Headers: {
          Acciones: this.configService.etiquetas.Acciones,
          Email: this.configService.etiquetas.Usuarios.Headers.Email,
          Nombre: this.configService.etiquetas.Usuarios.Headers.Nombre,
          Habilitacion: this.configService.etiquetas.Habilitacion,
          UserName: this.configService.etiquetas.Usuarios.Headers.UserName,
          Rol: this.configService.etiquetas.Usuarios.Headers.Rol
        }

      }
      this.Tooltips = {
        Editar: this.configService.tooltips.Editar,
        Eliminar: this.configService.tooltips.Eliminar,
        Ver: this.configService.tooltips.Ver
      }

      this.buscar(0);
    }

  }

  buscar(idTipoMensaje: number) {


    this.usuariosService
      .cUsuarios()
      .subscribe((data: UsuariosDataGrilla) => {
        this.dataSource.data = [];
        if (data.usuarios.length) {

          this.dataSource.data = data.usuarios;
          if (data.rolesConRegion.length) {
            this.rolesConRegion = [];
            this.rolesConRegion = data.rolesConRegion;
          }

          if (data.rolesMultiDivision.length) {
            this.rolesMultiDivision = [];
            this.rolesMultiDivision = data.rolesMultiDivision;
          }


          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExcelExitosa, 1, 1)
              break;
          }
        }

      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  onRowExpand(u: Usuario) {
    //if (u != this.usuarioSeleccionado) {
    this.usuarioSeleccionado = u;
    this.divisionesUsuario = "Divisiones: ";
    this.paisesUsuario = "Paises: ";
    this.usuariosService.cUsuarioDB(u.codigo, u.userName).subscribe((data: Usuario) => {
      if (data.paises.length) {
        var paises = data.paises.map(function (item) {
          return item['descripcion'];
        });
        this.paisesUsuario = "Paises: " + paises.join(' , ')
      }
      if (data.divisiones.length) {
        var divisiones = data.divisiones.map(function (item) {
          return item['displayValue'];
        });
        this.divisionesUsuario = "Divisiones: " + divisiones.join(' ; ')
      }
    })
    // }
  }

  dialogUsuario(idTipo: number, u: Usuario) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { usuario: u, rolesConRegion: this.rolesConRegion, rolesMultiDivision: this.rolesMultiDivision, idTipo: idTipo }
    let dialogRef = this.dialog.open(UsuariosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: Usuario) => {
      if (data != null) {
        this.buscar(idTipo);
      }

    })
  }

  eliminarUsuario(usuario: Usuario) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del usuario " + usuario.nombreApellido + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.usuariosService.bUsuario(usuario).subscribe((u: Usuario) => {
            const index = this.dataSource.data.findIndex(c => c.userName == u.userName)
            this.dataSource.data.splice(index, 1)
            this.dataSource.data = [...this.dataSource.data]
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
          })
        }
      })
  }


  cReporteExcel() {
    this.loadingReporte = true;
    this.botonReporte = this.configService.etiquetas.Descargando;
    let timer = setTimeout(() => {
      this.loadingReporte = false;
      this.botonReporte = this.configService.etiquetas.BotonReporte;
    }, 120000);
    this.reportesSevice
      .cReporteExcelUsuarios()
      .subscribe((reporte: ReporteExcelUsuarios) => {


        this.exporExcelService.cExcelReporteUsuarios(reporte);
        this.loadingReporte = false;
        this.botonReporte = this.configService.etiquetas.BotonReporte;
      })
  }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
